import { FormEventHandler, useMemo } from 'react';

import { FiArrowLeft } from 'react-icons/fi';

import { routes } from '~/shared/constants/routes';

import { usePasswordRecovery } from '~/modules/auth/hooks/usePasswordRecovery';

import { Collapse } from '~/shared/components/Collapse';
import { Button } from '~/shared/components/Button';
import { AuthLink } from '~/shared/components/AuthLink';

import { WithChildren } from '~/shared/types/WithChildren';

import { Container } from './styles';

interface IStepWrapperProps {
  step: number;
  onSubmit(): void | Promise<void>;
  isSubmitting?: boolean;
}

export const StepWrapper: WithChildren<IStepWrapperProps> = ({
  children,
  step,
  onSubmit = () => null,
  isSubmitting = false,
}) => {
  const { currentStep } = usePasswordRecovery();

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    onSubmit?.();
  };

  const submitButtonTitle = useMemo(() => {
    return {
      1: 'Continuar',
      2: 'Recuperar',
      3: 'Continuar',
      4: 'Redefinir',
    }[currentStep];
  }, [currentStep]);

  return (
    <Container onSubmit={handleSubmit} currentStep={currentStep} step={step}>
      <Collapse isOpen={currentStep === step} startingHeight={100}>
        {children}

        <Button type="submit" mt="md" size="lg" isLoading={isSubmitting}>
          {submitButtonTitle}
        </Button>

        <AuthLink
          href={routes.AUTH.SIGN_IN}
          icon={FiArrowLeft}
          title="Voltar para o login"
        />
      </Collapse>
    </Container>
  );
};
